/* global axios */
import ApiClient from './ApiClient';

/**
 * AI Assist (Inbox Reply Mode = Semi-Auto) client. singabot owns the endpoints; the dashboard
 * reaches them only through the Rails proxy `/api/v1/accounts/:id/proxy/knowledge/*`, the same
 * base the chatbot config screen uses. `conversationId` is always the conversation display id.
 *
 * Error bodies: `{ detail: { code, message } }` with code one of conversation_not_found,
 * summary_not_found, not_semi_auto, insufficient_credits, already_running, invalid_action.
 */
class AiAssistAPI extends ApiClient {
  constructor() {
    super('proxy/knowledge', { accountScoped: true });
  }

  conversationUrl(conversationId) {
    return `${this.url}/ai-assist/accounts/${this.accountIdFromRoute}/conversations/${conversationId}`;
  }

  /** `{ mode, summary: run|null, replies: [run] }` */
  getState(conversationId) {
    return axios.get(this.conversationUrl(conversationId));
  }

  /** Regenerate the summary. 202 → pending summary run. */
  regenerateSummary(conversationId) {
    return axios.post(`${this.conversationUrl(conversationId)}/summary`);
  }

  /** Ask for a suggested reply for one action of a ready summary. 202 → pending reply run. */
  requestReply(conversationId, { summaryRunId, actionIndex }) {
    return axios.post(`${this.conversationUrl(conversationId)}/replies`, {
      summary_run_id: summaryRunId,
      action_index: actionIndex,
    });
  }
}

export default new AiAssistAPI();
